﻿import $ from 'jquery'
import Focus from "../utilities/focusfield";

declare global {
  interface JQuery {
    tabs(option?: any): JQuery;
  }
}

export class Tabs {
  static get wireup(): string {
    return '[data-tabs]';
  }

  private DEFAULTS: ITabsOptions = {
    selectedTabClass: null,
  };

  private options: ITabsOptions;
  constructor(private $tabs: JQuery, options: ITabsOptions) {
    this.options = $.extend(this.DEFAULTS, $tabs.data());
    this.$tabs.on('click.rustig.tabs', '[data-tab]', (e: JQueryEventObject) => {
      this.selectTab(<JQuery> $(e.currentTarget));
    })

    this.selectInitialTab();
    this.applyErrors();
  }

  public selectTab($tab: JQuery): void {
    var tabId = $tab.data('tab');

    if (this.options.selectedTabClass) {
      this.$tabs.find('[data-tab]').removeClass(this.options.selectedTabClass);
      $tab.addClass(this.options.selectedTabClass);
    }

    this.$tabs.find('[data-tab-content]').removeClass('selected');
    var $content = this.findContent(tabId);
    $content.addClass('selected');
    Focus.autoFocus($content);
  }

  public applyErrors() {
    this.$tabs.find('[data-tab-content] .input-validation-error').each((i, e) => {
      var $content = $(e).closest('[data-tab-content]');
      let tabId = $content.data('tab-content');
      let $tab = this.findTab(tabId);

      if ($tab.data('rustig.tabs.error-handled') === true)
        return;

      $tab.data('rustig.tabs.error-handled', true)
      this.addErrorIconToTab($tab);
    });
  }

  private addErrorIconToTab($tab: JQuery) {
    var $errorIcon = $('<i class="icon-tab-error">');
    var $tabIcon = $tab.find('[class *= "icon-"]');

    if ($tabIcon.length > 0)
      $tabIcon.replaceWith($errorIcon);
    else
      $tab.append($errorIcon);
  }

  private findContent(tabId: string): JQuery {
    return this.$tabs.find('[data-tab-content="' + tabId + '"]');
  }

  private findTab(tabId: string): JQuery {
    return this.$tabs.find('[data-tab="' + tabId + '"]');
  }

  private selectInitialTab() {
    var $allTabs = this.$tabs.find('[data-tab]');
    if (this.options.selectedTabClass) {
      var $selectedTabs = $allTabs.filter('.' + this.options.selectedTabClass);
      if ($selectedTabs.length == 0)
        this.selectTab($allTabs.first());
      else
        this.selectTab($selectedTabs.first());
    }
    else {
      this.selectTab($allTabs.first());
    }
  }

  public static applyErrors() {
    $(Tabs.wireup).each(function () {
      var tabs = $(this).data('rustig.tabs');
      if (tabs)
        tabs.applyErrors();
    });
  }
}

export interface ITabsOptions {
  selectedTabClass?: string;
}

(function ($) {
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('rustig.tabs');
      var options = typeof option == 'object' && option;

      if (!data) {
        data = new Tabs($this, options);
        $this.data('rustig.tabs', data);
      }
      if (typeof option == 'string') {
        data[option]();
      }
    });
  }
  (<any>$.fn).tabs = Plugin;

})($);